<template>
	<h2 class="text-3xl font-semibold mb-4">What is this tool for?</h2>

	<p>
		This tool is for uploading email marketing lists into Mailchimp relatively hassle free. If
		you are not part of the marketing team you probably shouldn’t be seeing this, please contact
		someone in Mabey’s marketing team so we can rectify the permissions accordingly.
	</p>

	<h3 class="text-xl font-semibold mt-5 mb-3">Which function do you need?</h3>

	<strong class="block mb-2"> Insert </strong>

	<p>
		The INSERT function is used to upload entirely new mailing lists to Mailchimp.
		<br /><br />
		Files used must be in .csv format.
	</p>

	<strong class="block mt-5 mb-2"> Update </strong>

	<p>
		The UPDATE function is used to update lists which already exist on Mailchimp, both with new
		contacts and updating existing ones.
		<br /><br />
		Files used must be in .csv format.
	</p>
</template>
